var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  className: "MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiBox-root css-lf3s84",
  focusable: "false",
  "aria-hidden": "true",
  viewBox: "0 0 24 24",
  "data-testid": "EditIcon"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
})));
export default __webpack_public_path__ + "teg/media/editIconT1.08a3148d.svg";
export { SvgComponent as ReactComponent };